import { useEffect } from "react";

const useTableShortcuts = ({
  handleCmdA,
  handleEsc,
}: {
  handleCmdA: () => void;
  handleEsc: () => void;
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Get the currently focused element
      const activeElement = document.activeElement;

      // Check if the active element is an input field, textarea, select, or has contentEditable attribute
      const isInputFocused =
        activeElement instanceof HTMLInputElement ||
        activeElement instanceof HTMLTextAreaElement ||
        activeElement instanceof HTMLSelectElement ||
        activeElement?.getAttribute("contenteditable") === "true" ||
        activeElement?.tagName === "BUTTON";

      // Only process shortcuts if no input is focused
      if (!isInputFocused) {
        // Handle cmd + A
        if ((event.metaKey || event.ctrlKey) && event.key === "a") {
          event.preventDefault();
          handleCmdA();
        }

        // Handle Esc
        if (event.key === "Escape") {
          event.preventDefault();
          handleEsc();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleCmdA, handleEsc]);

  return null;
};

export default useTableShortcuts;
